import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES } from '@/utils/constants'
import { requireAuthenticatedUser } from '@/router/guards'

export const cardRoutes: RouteRecordRaw[] = [
  {
    path: '/cards',
    name: ROUTES.CARDS,
    component: () => import('@/modules/cards/views/CardsIndex.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.CARD_PASSES_VIEW }
  },
  {
    path: '/cards/:id',
    name: ROUTES.CARD_DETAILS,
    component: () => import('@/modules/cards/views/CardDetails.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.CARD_PASS_DETAILS_VIEW }
  }
]
